let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("faSqj")).then(() => parcelRequire('fP80T'));